export const DEFAULT_CURRENCY = {
  code: "AUD",
  locale: "en-AU"
};

// Currency code to locale mapping
export const CURRENCY_LOCALE_MAP: Record<string, string> = {
  USD: "en-US",
  CAD: "en-CA",
  MXN: "es-MX",
  BRL: "pt-BR",
  ARS: "es-AR",
  CLP: "es-CL",
  COP: "es-CO",
  PEN: "es-PE",
  EUR: "de-DE", // Using German locale as default for Euro
  GBP: "en-GB",
  CHF: "de-CH",
  JPY: "ja-JP",
  CNY: "zh-CN",
  HKD: "zh-HK",
  TWD: "zh-TW",
  KRW: "ko-KR",
  SGD: "en-SG",
  AUD: "en-AU",
  NZD: "en-NZ",
  INR: "en-IN",
  PKR: "ur-PK",
  PHP: "en-PH",
  IDR: "id-ID",
  THB: "th-TH",
  VND: "vi-VN",
  MYR: "ms-MY",
  AED: "ar-AE",
  SAR: "ar-SA",
  QAR: "ar-QA",
  ILS: "he-IL",
  TRY: "tr-TR",
  ZAR: "en-ZA",
  EGP: "ar-EG",
  NGN: "en-NG",
  KES: "sw-KE"
};

/**
 * Formats a number as currency with the correct locale and symbol
 * @param value The number to format
 * @param currencyCode The ISO 4217 currency code (e.g., 'USD', 'EUR', 'PHP')
 * @returns Formatted currency string
 */
export function formatCurrency(
  value: number | string,
  currencyCode: string
): string {
  const code = currencyCode?.toUpperCase() ?? DEFAULT_CURRENCY.code;
  const locale = CURRENCY_LOCALE_MAP[code] || DEFAULT_CURRENCY.locale;
  if (Number.isNaN(Number.parseInt(value as string))) {
    return "";
  }
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: code
  }).format(value as number);
}
